// extracted by mini-css-extract-plugin
export default {"outer":"ChooseCard_outer__jpzNm","underLine":"ChooseCard_underLine__ZRQnv"};